
// Unit types as a string union type for better TypeScript support
export type UnitType = string;

// Keep the enum for backward compatibility but make it string-based
export enum UnitTypeEnum {
  HR = "hr",      // hour
  DAY = "day",     // day
  ITEM = "item",    // item
  SQM = "m²",      // square meter
  CBM = "m³",      // cubic meter
  BOX = "box",     // box
  EACH = "each",    // each
  LINEAR_M = "linear_m", // linear meter
  KG = "kg",      // kilogram
  L = "l"       // liter
}

// Define a union type of valid unit values
export type ValidUnitValue = "hr" | "day" | "item" | "m²" | "m³" | "box" | "each" | "linear_m" | "kg" | "l";

export const unitOptions = [
  { value: "hr", label: "Hour", symbol: "hr" },
  { value: "day", label: "Day", symbol: "day" },
  { value: "item", label: "Item", symbol: "item" },
  { value: "m²", label: "Square Meter", symbol: "m²" },
  { value: "m³", label: "Cubic Meter", symbol: "m³" },
  { value: "box", label: "Box", symbol: "box" },
  { value: "each", label: "Each", symbol: "ea" },
  { value: "linear_m", label: "Linear Meter", symbol: "m" },
  { value: "kg", label: "Kilogram", symbol: "kg" },
  { value: "l", label: "Liter", symbol: "l" },
];

export const getUnitLabel = (unit: UnitType | null | string): string => {
  if (!unit) return "";
  const option = unitOptions.find(opt => opt.value === unit);
  return option ? option.label : unit;
};

export const getUnitSymbol = (unit: UnitType | null | string): string => {
  if (!unit) return "";
  const option = unitOptions.find(opt => opt.value === unit);
  return option ? option.symbol : unit.toString();
};

export const isValidUnitType = (value: string): boolean => {
  const systemUnitValues = unitOptions.map(option => option.value);
  return systemUnitValues.includes(value) || typeof value === 'string';
};

export const validateUnitType = (value: string): UnitType => {
  if (isValidUnitType(value)) {
    return value as UnitType;
  }
  // Return a default value if the input is not valid
  return 'item';
};

// Type assertion helper
export const asValidUnit = (value: string): ValidUnitValue => {
  const unitValues = unitOptions.map(option => option.value);
  if (unitValues.includes(value)) {
    return value as ValidUnitValue;
  }
  return "item" as ValidUnitValue; // Default to 'item' if not valid
};
